"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _reduxApiMiddleware = require("redux-api-middleware");

var _actions = require("./store/actions");

var _helpers = require("./helpers");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var refreshPromise = null;

function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$authConfig = _ref.authConfig,
      authConfig = _ref$authConfig === void 0 ? {
    header: 'Authorization',
    type: 'Bearer'
  } : _ref$authConfig,
      refreshConfig = _ref.refreshConfig;

  if (refreshConfig && !refreshConfig.endpoint) {
    throw new Error('You must set the endpoint for refreshing token.');
  }

  return function (store) {
    if (!store.getState().auth) {
      throw new Error('You must add authReducer to your store before using refreshMiddleware.');
    }

    return function (next) {
      return function (action) {
        var apiCall = action[_reduxApiMiddleware.RSAA];

        var nextAuth = function nextAuth(action) {
          return next(_defineProperty({}, _reduxApiMiddleware.RSAA, _objectSpread({}, action[_reduxApiMiddleware.RSAA], {
            headers: typeof action[_reduxApiMiddleware.RSAA].headers !== 'function' ? _objectSpread({}, action[_reduxApiMiddleware.RSAA].headers, _defineProperty({}, authConfig.header, "".concat(authConfig.type, " ").concat(store.getState().auth.accessToken))) : action[_reduxApiMiddleware.RSAA].headers
          })));
        };

        if (apiCall) {
          if (apiCall.skipAuth) {
            delete apiCall.skipAuth;
            return next(action);
          }

          var _store$getState$auth = store.getState().auth,
              accessToken = _store$getState$auth.accessToken,
              refreshToken = _store$getState$auth.refreshToken,
              expires = _store$getState$auth.expires;

          if (accessToken) {
            if (refreshConfig && (0, _helpers.isTokenExpired)(expires)) {
              if (!refreshPromise) {
                refreshPromise = store.dispatch(refreshConfig.actionDefinition ? refreshConfig.actionDefinition({
                  refreshToken: refreshToken,
                  endpoint: refreshConfig.endpoint
                }) : (0, _actions.refreshTokenAction)({
                  refreshToken: refreshToken,
                  endpoint: refreshConfig.endpoint
                })).then(function (apiCall) {
                  refreshPromise = null;
                  return apiCall;
                });
              }

              if (refreshPromise) {
                return refreshPromise.then(function (apiCall) {
                  if (apiCall.error) {
                    return store.dispatch(refreshConfig.failedAction);
                  }

                  return nextAuth(action);
                });
              }
            }

            return nextAuth(action);
          }
        }

        return next(action);
      };
    };
  };
}